import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { Subject } from "rxjs";
import { MerchantBanking } from "src/app/shared/models/FocusPay/FocusPayApplication.item";

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		const isSubmitted = form && form.submitted;
		return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}

@Component({
	selector: "app-application-banking-information",
	templateUrl: "./application-banking-information.component.html",
	styleUrls: ["../../focuspay.style.scss"],
})
export class ApplicationBankingInformationComponent implements OnInit {
	@Input() merchantBanking: MerchantBanking;
	@Input() readOnly: boolean;
	@Output() merchantBankingEmitter = new EventEmitter<MerchantBanking>();
	@Output() displayModal = new EventEmitter<string>();
	@Output() inputActionEmitter = new EventEmitter<any>();
	@Output() sectionCompleteEmitter = new EventEmitter<any>();
	sectionStatus: Subject<any> = new Subject<any>();

	bankName: UntypedFormControl;
	bankAccountNumberControl: UntypedFormControl;
	bankRoutingNumberControl: UntypedFormControl;

	matcher = new MyErrorStateMatcher();

	sectionComplete: boolean = false;

	constructor() {}

	ngOnInit(): void {
		this.bankName = new UntypedFormControl({ value: this.merchantBanking.bankName, disabled: this.readOnly }, [Validators.required]);
		this.bankAccountNumberControl = new UntypedFormControl({ value: this.merchantBanking.accountNumber, disabled: this.readOnly }, [
			Validators.required,
			Validators.maxLength(17),
			Validators.minLength(6),
			Validators.pattern("[0-9]*"),
		]);

		this.bankRoutingNumberControl = new UntypedFormControl({ value: this.merchantBanking.routingNumber, disabled: this.readOnly }, [
			Validators.required,
			Validators.maxLength(9),
			Validators.minLength(9),
			Validators.pattern("[0-9]*"),
		]);
		setTimeout(() => {
			this.inputAction();
		}, 500);
	}

	inputAction(inputEvent?) {
		inputEvent && this.inputActionEmitter.emit(inputEvent);
		this.sectionStatus.next({
			section: "banking",
			complete: false,
		});
		this.sectionComplete = false;
		if (!this.bankName.pristine && this.bankName.errors) return;
		if (!this.bankAccountNumberControl.pristine && this.bankAccountNumberControl.errors) return;
		if (!this.bankRoutingNumberControl.pristine && this.bankRoutingNumberControl.errors) return;

		this.sectionComplete = true;
		this.sectionStatus.next({
			section: "banking",
			complete: true,
		});
	}
}
